import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Exploreindiapanindiacab() {



    const cardData = {





keyword: "Explore India / Pan India Cab Booking Services",

headingDescription: "Shreesha Tours & Travels offers reliable and affordable Pan India Cab Booking Services from Mumbai for one-way travel, round trips, multi-city tours, family vacations, corporate travel, pilgrimage journeys, destination weddings, sightseeing holidays, airport transfers, business visits, and long-distance road trips across India. We provide chauffeur-driven Sedan, SUV, Ertiga, Kia Carens, Innova, Innova Crysta, Tempo Traveller, Urbania, Mini Bus, and luxury vehicles to suit every travel requirement. Whether you are planning a short interstate journey or an extended tour across multiple states, our experienced drivers, well-maintained fleet, transparent pricing, customized travel itineraries, doorstep pickup, and 24/7 customer support ensure a safe, comfortable, and hassle-free experience. Shreesha Tours & Travels connects Mumbai with every major tourist destination, business city, pilgrimage center, hill station, beach destination, and heritage site across India, making us your trusted travel partner for exploring the country by road with complete comfort and convenience.",

topPlaces: [
  {
    title: "Mumbai to Leh Ladakh",
    description: "Leh Ladakh is India's ultimate road trip destination, famous for Pangong Lake, Nubra Valley, Khardung La Pass, Magnetic Hill, monasteries, and breathtaking Himalayan landscapes."
  },
  {
    title: "Mumbai to Amritsar",
    description: "Amritsar is home to the world-famous Golden Temple, Jallianwala Bagh, Wagah Border, and vibrant Punjabi culture, making it one of India's most visited pilgrimage and heritage destinations."
  },
  {
    title: "Mumbai to Varanasi",
    description: "Varanasi is one of the world's oldest living cities, renowned for Kashi Vishwanath Temple, Dashashwamedh Ghat, Ganga Aarti, and its deep spiritual significance."
  },
  {
    title: "Mumbai to Delhi",
    description: "Delhi, India's capital city, offers iconic attractions including India Gate, Red Fort, Qutub Minar, Lotus Temple, Akshardham, and vibrant shopping markets."
  },
  {
    title: "Mumbai to Agra",
    description: "Agra is world-famous for the Taj Mahal, Agra Fort, Mehtab Bagh, and Mughal heritage. It is one of India's top destinations for family holidays and heritage tours."
  },
  {
    title: "Mumbai to Shimla",
    description: "Shimla is a charming Himalayan hill station known for Mall Road, Kufri, Jakhoo Temple, Christ Church, toy train rides, and colonial architecture."
  },
  {
    title: "Mumbai to Manali",
    description: "Manali is a favorite destination for honeymooners and adventure lovers, offering Solang Valley, Rohtang Pass, Hidimba Temple, snow activities, and scenic mountain views."
  },
  {
    title: "Mumbai to Ooty",
    description: "Ooty is a beautiful hill station in Tamil Nadu famous for Botanical Gardens, Ooty Lake, Doddabetta Peak, tea plantations, and the Nilgiri Mountain Railway."
  },
  {
    title: "Mumbai to Kanyakumari",
    description: "Kanyakumari is India's southernmost destination, known for Vivekananda Rock Memorial, Thiruvalluvar Statue, sunrise and sunset views, and the confluence of three seas."
  },
  {
    title: "Mumbai to Puri",
    description: "Puri is one of the Char Dham pilgrimage sites, famous for Jagannath Temple, Golden Beach, Konark Sun Temple, and Chilika Lake, making it an ideal destination for religious and family tours."
  }
],


"services": [
  {
    "name": "Pan India Cab Booking Services",
    "description": "Book Pan India Cab Booking Services for safe, comfortable, and reliable travel across India with experienced chauffeurs and well-maintained AC vehicles. Choose from Sedan, Ertiga, Innova, Innova Crysta, Kia Carens, SUV, Tempo Traveller, and luxury vehicles for one way trips, round trips, business travel, family vacations, pilgrimage tours, and long-distance interstate journeys. Enjoy transparent pricing, flexible booking options, and 24x7 customer support."
  },
  {
    "name": "India Tour Cab Booking",
    "description": "Choose India Tour Cab Booking for customized travel across popular tourist destinations with professional drivers and comfortable vehicles. Whether you are planning a family vacation, honeymoon, pilgrimage, wildlife tour, heritage tour, or business trip, we provide reliable chauffeur-driven cab services with personalized travel plans."
  },
  {
    "name": "Explore India Cab Service",
    "description": "Book Explore India Cab Service to discover beautiful destinations across the country with spacious vehicles and experienced chauffeurs. Travel comfortably to hill stations, beaches, temples, heritage sites, wildlife sanctuaries, and major cities with flexible one way and round trip cab packages."
  },
  {
    "name": "Pan India Taxi Service",
    "description": "Hire Pan India Taxi Service for convenient interstate and intercity travel with professional drivers, clean AC vehicles, and affordable pricing. Our nationwide taxi service is perfect for business travel, holiday tours, airport transfers, family trips, and long-distance road journeys."
  },
  {
    "name": "All India Cab Booking",
    "description": "Book All India Cab Booking with instant confirmation, transparent fares, and a wide range of vehicles suitable for every travel requirement. Enjoy reliable chauffeur-driven transportation for corporate travel, personal trips, religious tours, airport transfers, and interstate travel throughout India."
  },
  {
    "name": "Nationwide Cab Service",
    "description": "Choose Nationwide Cab Service for seamless travel across multiple states with experienced drivers, premium vehicles, and dependable customer support. Whether you need transportation for business meetings, vacations, family events, or road trips, we provide safe and comfortable travel solutions."
  },
  {
    "name": "India Outstation Taxi Service",
    "description": "Reserve India Outstation Taxi Service for one way and round trip travel to cities, towns, tourist attractions, pilgrimage destinations, and business hubs across India. Enjoy spacious vehicles, skilled chauffeurs, competitive pricing, and comfortable long-distance travel."
  },
  {
    "name": "Multi City Cab Booking India",
    "description": "Book Multi City Cab Booking India for flexible travel covering multiple destinations in a single trip. Ideal for corporate tours, family vacations, pilgrimage circuits, sightseeing holidays, educational tours, and customized travel itineraries with experienced drivers."
  },
  {
    "name": "Long Distance Cab Service India",
    "description": "Hire Long Distance Cab Service India for safe interstate road travel with clean AC vehicles, professional chauffeurs, and reliable customer support. Perfect for extended business trips, family holidays, cross-country travel, and leisure tours with flexible travel schedules."
  },
  {
    "name": "India Tour Package by Cab",
    "description": "Choose India Tour Package by Cab for customized sightseeing tours covering famous destinations, heritage cities, beaches, hill stations, temples, and cultural attractions. Travel in comfort with chauffeur-driven vehicles, personalized itineraries, and affordable tour packages."
  },
  {
    "name": "Family Tour Cab India",
    "description": "Book Family Tour Cab India for safe and enjoyable vacations with spacious vehicles, comfortable seating, and experienced drivers. Ideal for family holidays, religious tours, sightseeing trips, wedding travel, and weekend getaways across India with flexible travel plans."
  },
  {
    "name": "Corporate Travel Cab India",
    "description": "Choose Corporate Travel Cab India for executive transportation, employee travel, client visits, airport transfers, conferences, exhibitions, and business meetings. Our professional chauffeurs and premium fleet ensure punctual, comfortable, and reliable corporate travel services across India."
  },
  {
    "name": "Airport Transfer Cab India",
    "description": "Reserve Airport Transfer Cab India for timely airport pickup and drop services at major airports across the country. Enjoy flight monitoring, luggage assistance, professional chauffeurs, and comfortable AC vehicles for stress-free airport transportation."
  },
  {
    "name": "Reliable Pan India Taxi Service",
    "description": "Book Reliable Pan India Taxi Service for dependable long-distance travel with courteous drivers, clean vehicles, transparent pricing, and 24x7 customer assistance. Whether you are traveling for business, tourism, family functions, or religious pilgrimages, our nationwide taxi service ensures a smooth and comfortable journey."
  },
  {
    "name": "Best India Cab Booking Service",
    "description": "Choose the Best India Cab Booking Service for premium chauffeur-driven transportation with a wide fleet of vehicles, experienced drivers, competitive pricing, and outstanding customer support. From airport transfers and city tours to interstate road trips, family vacations, corporate travel, pilgrimage tours, and customized holiday packages, we provide safe, reliable, and comfortable cab services across India with flexible one way and round trip booking options."
  }
],
"tableData": [
  ["Pan India Cab Booking Services", "India Tour Cab Booking"],
  ["Explore India Cab Service", "Pan India Taxi Service"],
  ["All India Cab Booking", "Nationwide Cab Service"],
  ["India Outstation Taxi Service", "Multi City Cab Booking India"],
  ["Long Distance Cab Service India", "India Tour Package by Cab"],
  ["Family Tour Cab India", "Corporate Travel Cab India"],
  ["Airport Transfer Cab India", "Reliable Pan India Taxi Service"],
  ["Best India Cab Booking Service", ""]
],




whychoose: [
  {
    WhyChooseheading: "Explore India with Trusted Pan India Cab Services",
    WhyChoosedescription: "Every journey becomes more memorable when you have reliable transportation. Shreesha Travels offers Pan India Cab Booking Services from Mumbai, connecting travellers to popular tourist destinations, business hubs, pilgrimage centres, hill stations, coastal towns, and major cities across India."
  },
  {
    WhyChooseheading: "One Cab Solution for Every Destination",
    WhyChoosedescription: "Whether you're travelling to Maharashtra, Goa, Gujarat, Karnataka, Rajasthan, Madhya Pradesh, Telangana, Tamil Nadu, Kerala, or any other state, our nationwide cab services provide convenient travel for individuals, families, and corporate travellers."
  },
  {
    WhyChooseheading: "Wide Range of Vehicles for Every Journey",
    WhyChoosedescription: "Choose from Swift Dzire, Toyota Etios, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, Luxury Cars, Tempo Travellers, Mini Buses, and premium group vehicles according to your travel plans and passenger count."
  },
  {
    WhyChooseheading: "Perfect for Holidays, Pilgrimages & Business Tours",
    WhyChoosedescription: "Our Pan India cab services are ideal for family vacations, religious yatras, destination weddings, corporate travel, educational tours, industrial visits, sightseeing holidays, and long-distance road trips."
  },
  {
    WhyChooseheading: "Flexible Travel Plans Across India",
    WhyChoosedescription: "Book one-way intercity taxis, round-trip journeys, multi-city tours, airport transfers, customized travel itineraries, or extended road trips with complete flexibility."
  },
  {
    WhyChooseheading: "Experienced Chauffeurs for Long-Distance Routes",
    WhyChoosedescription: "Our professional drivers are experienced in interstate travel, national highways, tourist circuits, and major travel routes, ensuring a safe, comfortable, and enjoyable journey throughout India."
  },
  {
    WhyChooseheading: "Comfortable Vehicles Ready for Every Adventure",
    WhyChoosedescription: "Every vehicle is regularly serviced, fully air-conditioned, sanitized, and inspected before departure to provide dependable performance on both short and long-distance journeys."
  },
  {
    WhyChooseheading: "Book Pan India Cabs with Shreesha Travels",
    WhyChoosedescription: "Enjoy transparent pricing, responsive customer support, customized travel planning, and reliable chauffeur-driven transportation for your next journey anywhere in India."
  }
]

};

const faqData = [
  {
    question: "What is included in your Pan India Cab Booking Service?",
    answer: "Our service includes chauffeur-driven cabs for interstate travel, one-way trips, round journeys, multi-city tours, airport transfers, holiday packages, and customized travel itineraries across India."
  },
  {
    question: "Can I travel across multiple states with one booking?",
    answer: "Yes, we can arrange customized travel plans covering multiple cities and states according to your itinerary."
  },
  {
    question: "Which vehicles are available for Pan India travel?",
    answer: "We offer Swift Dzire, Toyota Etios, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, Luxury Cars, Tempo Travellers, Mini Buses, and other chauffeur-driven vehicles."
  },
  {
    question: "Do you provide cabs for religious tours and pilgrimage circuits?",
    answer: "Yes, we arrange transportation for Jyotirlinga tours, Char Dham routes, temple visits, spiritual circuits, and other pilgrimage journeys across India."
  },
  {
    question: "Can companies book cabs for interstate business travel?",
    answer: "Yes, our Pan India services are suitable for corporate executives, client visits, industrial tours, conferences, exhibitions, and official travel."
  },
  {
    question: "Are multi-day and long-distance packages available?",
    answer: "Yes, we offer customized multi-day road trips, holiday packages, and extended travel plans based on your schedule."
  },
  {
    question: "Can I modify my itinerary after booking?",
    answer: "Yes, itinerary changes can be accommodated depending on the travel schedule and operational availability."
  },
  {
    question: "How are Pan India cab charges calculated?",
    answer: "The fare depends on the selected vehicle, travel distance, number of travel days, route, state permits, and the overall itinerary."
  },
  {
    question: "Is advance booking recommended for interstate travel?",
    answer: "Yes, advance reservations help ensure vehicle availability and allow better planning for long-distance travel."
  },
  {
    question: "How can I book Explore India / Pan India Cab Booking Services with Shreesha Travels?",
    answer: "Simply share your departure city, destinations, travel dates, passenger count, preferred vehicle, and complete itinerary to receive a customized quotation and instant booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Siddharth Jain",
    feedback: "Travelling across multiple states was remarkably comfortable thanks to the well-planned itinerary and dependable service. The journey remained smooth from the first destination to the last.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Anusha Reddy",
    feedback: "The flexibility to customize our route and the comfort of the vehicle made our India tour truly memorable. Professional coordination and excellent travel support were maintained throughout the trip.",
    rating: 5
  }
];








    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Explore India / Pan India Cab Booking Services",
  "image": "https://www.shreeshatravels.com/assets/images/pan-india-cab-booking-services.webp",
  "description":
    "Book Pan India Cab Booking Services with Shreesha Tours & Travels for comfortable, reliable, and affordable nationwide taxi solutions. We provide Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for India tours, multi-city travel, business trips, family vacations, pilgrimage tours, airport transfers, and long-distance outstation journeys across India.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/pan-india-cab-booking-services"
  }
};



    return (
        <div>
<Helmet>
  <title>Pan India Cab Booking Services | Explore India by Car | +91 8355835813</title>

  <meta
    name="description"
    content="Book Pan India Cab Booking Services with Shreesha Travels for reliable nationwide taxi services. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta for India tours, multi-city travel, business trips, family vacations, and outstation journeys with 24x7 booking."
  />

  <meta
    name="keywords"
    content="Pan India Cab Booking Services, India Tour Cab Booking, Explore India Cab Service, Pan India Taxi Service, All India Cab Booking, Nationwide Cab Service, India Outstation Taxi Service, Multi City Cab Service, Long Distance Cab Booking India, India Tour Package Cab, All India Taxi Booking, Pan India Car Rental"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/57.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Exploreindiapanindiacab;